import styled from "styled-components";
import reactjs from "../../assets/images/projects/react.png";
import svelte from "../../assets/images/projects/svelte.png";
import xamarin from "../../assets/images/projects/xamarin.png";
import aspnetcore from "../../assets/images/projects/aspnetcore.jpg";
import vue from "../../assets/images/projects/vue.png"

export const imgMapping = {
  "React JS": reactjs,
  "React Native": reactjs,
  "Svelte JS": svelte,
  "Xamarin": xamarin,
  "ASP.NET Core":aspnetcore,
  "Vue JS": vue,
};

export const FrameworkImage = styled.div`
  align-self: center;
  background-image: url(${(props) => props.state ? imgMapping[props.state] : { reactjs }});
  height: 150px;
  background-position: center;
  background-size: cover;
  width: 110px;
  animation: 1s ease-out 0s 1 Appear;

  @media (max-width: 500px) {
    width: 75px;
    height: 105px;
  }
`;

